import React from 'react';
import { useServiceClient } from 'common';
import { SharedEndPoints, SharedReactQueryKey } from './query-enum';
import { readFileAsDataUrl } from '@agilepoint/utils-common';
import { useQuery } from 'react-query';

export interface IImageMetadata {
    ID: string;
    Name: string;
}

export const useGetUploadedImagesQuery = (selectedIds?: IImageMetadata[]) => {
    const { getData } = useServiceClient();

    const getURL = React.useCallback(async (imageDataResponse: Response, name: string) => {
        const blob = await imageDataResponse.clone().blob();
        const file = new File([blob], name);
        return await readFileAsDataUrl(file);
    }, []);

    const getImageData = React.useCallback(async (id, name) => {
        const response = await getData(`${SharedEndPoints.GET_BINARY_DATA}${id}`);
        const imageUrl = await getURL(response, name);
        return { name, imageUrl };
    }, [getData, getURL]);

    const getQueryFunction = () => {
        if (selectedIds) {
            return Promise.all(selectedIds.map(({ ID, Name }) => getImageData(ID, Name)));
        }
        return Promise.reject('Id not found');
    };

    return useQuery(SharedReactQueryKey.GET_BINARY_DATA, getQueryFunction, { enabled: !!selectedIds });
};
